import { SUBSCRIBE_CHANNEL } from '../constants';
import createEntityLocalizer from '../utils/createEntityLocalizer';

interface LocalizedLongDateProps<D> {
    date: D;
}

export const createLocalizedLongDate = <D,>({
    subscribeChannelKey = SUBSCRIBE_CHANNEL,
    handlerKey = 'localizeLongDate',
} = {}) =>
    createEntityLocalizer<LocalizedLongDateProps<D>>({
        subscribeChannelKey,
        handlerKey,
        displayName: 'LocalizedLongDate',
        entityName: 'date',
    });

export default createLocalizedLongDate();
